export default function randomSpin(finalAngle, next, startingAngle) {
  if (startingAngle >= 80 && startingAngle <= 110) {
    return 6;
  }

  if (next === "1") {
    if (finalAngle >= 60 && finalAngle <= 90) {
      return ((finalAngle - 60) / (90 - 60)) * 4 + 2;
    }
    if (finalAngle >= 91 && finalAngle <= 120) {
      return ((finalAngle - 91) / (120 - 91)) * 4;
    }
  } else {
    if (finalAngle >= 91 && finalAngle <= 120) {
      return ((finalAngle - 91) / (120 - 91)) * 4;
    }
    if (finalAngle <= 91 && finalAngle >= -20) {
      return ((finalAngle + 20) / (91 + 20)) * 4 + 2;
    }
  }
}
